export interface EligibilityCheckStrategy<T> {
  check(context: T): boolean
}

export class EligibilityChecker<T> {
  constructor(
    private readonly strategies: Array<EligibilityCheckStrategy<T>>
  ) {}

  check(context: T): boolean {
    return this.strategies.every(strategy => strategy.check(context))
  }
}
